if (!customElements.get('countdown-pill')) {
  customElements.define(
    'countdown-pill',
    class CountdownPill extends HTMLElement {
      static TIME_ZONE = 'Europe/Berlin';

      constructor() {
        super();

        this.counter = this.querySelector('[data-countdown-value]');
        this.mode = this.dataset.mode || 'daily';
        this.formatter = new Intl.DateTimeFormat('en-GB', {
          timeZone: CountdownPill.TIME_ZONE,
          hourCycle: 'h23',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        });

        if (this.mode === 'fixed') {
          this.endTime = this.parseBerlinDate(this.dataset.end);
          if (this.endTime === null) {
            this.hidden = true;
            return;
          }
        }
      }

      connectedCallback() {
        if (this.hidden || !this.counter) return;

        this.tick();
        this.removeAttribute('data-pending');
        this.timer = setInterval(this.tick.bind(this), 1000);
      }

      disconnectedCallback() {
        if (this.timer) clearInterval(this.timer);
      }

      // Partes da data/hora atuais no fuso de Berlim, iguais para qualquer visitante.
      berlinParts(date) {
        const parts = {};
        this.formatter.formatToParts(date).forEach(({ type, value }) => {
          if (type !== 'literal') parts[type] = parseInt(value, 10);
        });
        return parts;
      }

      // "AAAA-MM-DD HH:MM" no horário de Berlim -> timestamp UTC (considera horário de verão).
      parseBerlinDate(value) {
        const match = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})$/.exec((value || '').trim());
        if (!match) return null;

        const [, y, mo, d, h, mi] = match.map(Number);
        const wallAsUtc = Date.UTC(y, mo - 1, d, h, mi);
        let guess = wallAsUtc;
        for (let i = 0; i < 2; i++) {
          const p = this.berlinParts(new Date(guess));
          const offset = Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second) - guess;
          guess = wallAsUtc - offset;
        }
        return guess;
      }

      secondsLeft() {
        if (this.mode === 'fixed') {
          return Math.floor((this.endTime - Date.now()) / 1000);
        }

        // Termina às 23:59:59 de Berlim e recomeça à meia-noite.
        const p = this.berlinParts(new Date());
        return 86399 - (p.hour * 3600 + p.minute * 60 + p.second);
      }

      tick() {
        const left = this.secondsLeft();

        if (left < 0) {
          clearInterval(this.timer);
          this.hidden = true;
          return;
        }

        const pad = (n) => String(n).padStart(2, '0');
        const hours = Math.floor(left / 3600);
        const mins = Math.floor((left % 3600) / 60);
        const secs = left % 60;
        this.counter.textContent = `${pad(hours)}:${pad(mins)}:${pad(secs)}`;
      }
    }
  );
}
